export const NO_ANSWER_CB_2_HOURS = 10001
export const FOLLOW_UP_PER_POLICY = 10002
export const FOLLOW_UP_TOMORROW = 10003
export const FOLLOW_UP_NEXT_WEEK = 10004
export const NONE = 10005
